import {
	Component,
	ComponentFactory,
	ComponentFactoryResolver,
	ComponentRef,
	HostBinding,
	OnDestroy,
	OnInit,
	ViewChild,
	ViewContainerRef
} from '@angular/core';
import {routeAnimation} from '../../../../../route.animation';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {FormsService} from '../../../../../_services/forms.service';
import {Subscription} from 'rxjs/Subscription';
import {PreviousUrlService} from '../../../../../_services/previous-url.service';
import {ReportsService} from '../../../../../_services/reports.service';
import {ActivatedRoute, Params} from '@angular/router';
import {ReportsShortcomingsCategories} from '../../../../../_interfaces/reports/reports-shortcomings-categories';
import {ReportsShortcomingsSubcategories} from '../../../../../_interfaces/reports/reports-shortcomings-subcategories';
import {ReportsShortcomingsMaterials} from '../../../../../_interfaces/reports/reports-shortcomings-materials';
import {ReportsShortcomingsTypes} from '../../../../../_interfaces/reports/reports-shortcomings-types';
import {ReportsShortcomingsActions} from '../../../../../_interfaces/reports/reports-shortcomings-actions';
import {ReportsBuildingsShortcomingsQuestionnaire} from '../../../../../_interfaces/reports/reports-buildings-shortcomings-questionnaire';
import {PageTitleService} from '../../../../../_services/page-title.service';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {BarcodeScannerComponent} from '../../../../../core/barcode-scanner/barcode-scanner.component';
import {ReportsBuildingsReports} from '../../../../../_interfaces/reports/reports-buildings-reports';
import {ApiService} from '../../../../../_interceptors/api.service';
import {ServerResponse} from '../../../../../_interfaces/server.response';
import {AuthenticationService} from '../../../../../_services/authentication.service';
import {Reports} from '../../../../../_interfaces/reports/reports';
import {User} from '../../../../../_interfaces/user';
import {debounceTime, tap} from 'rxjs/operators';
import {environment} from '../../../../../../environments/environment';
import {ReportsBuildings} from '../../../../../_interfaces/reports/reports-buildings';
import {SpeechToTextComponent} from '../../../../../core/speech-to-text/speech-to-text.component';
import {FileInputComponent} from 'ngx-material-file-input';
import {RemovablePhotoComponent} from '../../../../../core/removable-photo/removable-photo.component';
import {ReportsBuildingsMapsMarker} from '../../../../../_interfaces/reports/reports-buildings-maps-marker';
import {ClientsBuildingMaps} from '../../../../../_interfaces/clients/clients-building-maps';
import {ClientsService} from '../../../../../_services/clients.service';

@Component({
	selector: 'app-reports-buildings-reports-edit',
	templateUrl: './reports-buildings-reports-edit.component.html',
	styleUrls: ['./reports-buildings-reports-edit.component.scss'],
	animations: [routeAnimation]
})

export class ReportsBuildingsReportsEditComponent implements OnInit, OnDestroy {

	@HostBinding('@routeAnimation') routerTransition = true;

	public report_type: string = null;
	public report_id: number = null;
	private report_status: string = null;
	public building_id: number = null;
	public building_report_id: number = null;
	public buildingReport: ReportsBuildingsReports = null;
	public dataLoaded: boolean = false;
	public missingData: Array<string> = [];
	public offlinePhoto: Array<any> = [];
	public reportEditable: boolean = false;

	public barcodeScannerActive: boolean = false;
	public speechToTextActive: boolean = true;

	public isVerifyingLocation: boolean = false;
	public locationNotUnique: boolean = false;
	public locationErrorMessage: string = null;
	public locationLink: string = null;

	public isVerifyingId: boolean = false;
	public idNotUnique: boolean = false;
	public idErrorMessage: string = null;
	public idLink: string = null;
	public companyInspection: boolean = true;

	public category_id: number = null;
	public subcategory_id: number = null;
	public categories: ReportsShortcomingsCategories[] = [];
	public subcategories: ReportsShortcomingsSubcategories[] = [];
	public actions: ReportsShortcomingsActions[] = [];
	public materials: ReportsShortcomingsMaterials[] = [];
	public types: ReportsShortcomingsTypes[] = [];
	public questionnaire: ReportsBuildingsShortcomingsQuestionnaire[] = [];

	public hasBuildingMap: boolean = false;
	public buildingMapUrl: string = null;
	public buildingMapMarkers: ReportsBuildingsMapsMarker[] = [];

	@ViewChild('photos', {read: ViewContainerRef, static: false}) photos: ViewContainerRef = null;
	@ViewChild('photosContainer', {static: false}) photosContainer: FileInputComponent;
	public photosRef: Array<ComponentRef<RemovablePhotoComponent>> = [];

	public reportsBuildingsReportEditForm = this.formBuilder.group({
		verify_status: [{value: '', disabled: true}],
		verify_inspector_status: [false],
		'photosContainer[]': [''],
		photos: this.formBuilder.array([]),
		marker: this.formBuilder.array([]),
	});

	private initialPhotosCount: number = 0;
	public photosCount: number = 0;

	private _errorsSubscription: Subscription = null;
	private _activatedRouteSubscription: Subscription = null;
	private _authenticationServiceSubscription: Subscription = null;

	constructor(private authenticationService: AuthenticationService,
				public apiService: ApiService,
				private resolver: ComponentFactoryResolver,
				public reportsService: ReportsService,
				public formsService: FormsService,
				private activatedRoute: ActivatedRoute,
				private pageTitleService: PageTitleService,
				private dialogService: MatDialog,
				private previousUrlService: PreviousUrlService,
				private clientsService: ClientsService,
				private formBuilder: FormBuilder) {
	}

	ngOnInit(): void {
		this.apiService.connectionChanged.subscribe(online => {
			if (online && this.missingData.length) {
				this.missingData = [];
				this.loadData();
			}
		});

		this.formsService.form = this.reportsBuildingsReportEditForm;

		this.reportsService.checkBarcodeScanner().then(response => {
			if (response) {
				this.barcodeScannerActive = true;
			}
		});

		this.reportsService.checkSpeechToText().then(response => {
			if (response) {
				this.speechToTextActive = true;
			}
		});

		this._activatedRouteSubscription = this.activatedRoute.params.subscribe((params: Params) => {
			this.report_type = params['report_type'];
			this.report_id = parseInt(params['report_id'], 10);
			this.building_id = parseInt(params['building_id'], 10);
			this.building_report_id = parseInt(params['building_report_id'], 10);

			this.reportsService.getReport(this.report_type, this.report_id).then((report: Reports) => {
				this._authenticationServiceSubscription = this.authenticationService.user.first().subscribe((user: User) => {
					if (typeof report !== 'undefined' && typeof user !== 'undefined') {
						this.report_status = report.status;

						this.reportsService.getBuilding(this.report_type, this.report_id, this.building_id).then((building: ReportsBuildings) => {
							if (typeof building.company_inspection !== 'undefined') {
								this.companyInspection = building.company_inspection;
								if ((this.report_type === 'ladders' || this.report_type === 'tent') && !building.company_inspection) {
									this.addTentLocationNr();
								}
							}
							this.clientsService.getBuildingMap(report.client_id, building.building_map_id).then((buildingMap: ClientsBuildingMaps) => {
								if (typeof buildingMap !== 'undefined') {
									this.hasBuildingMap = true;
									this.buildingMapUrl = buildingMap.map_url;

									this.reportsService.getBuildingMapMarkers(this.report_id, this.building_id, this.building_report_id).then((mapMarkers: ReportsBuildingsMapsMarker[]) => {
										this.buildingMapMarkers = mapMarkers;
									});
								}
							});

							if (this.report_type === 'warehouse') {
								this.pageTitleService.setTitle(building.name + ' | Aanpassen schade toevoegen | ' + environment.webappName);
							} else if (this.report_type === 'ladders') {
								this.pageTitleService.setTitle(building.name + ' | Aanpassen inspectie | ' + environment.webappName);
							} else {
								this.pageTitleService.setTitle(building.name + ' | Aanpassen tent inspectie | ' + environment.webappName);
							}
							this.pageTitleService.setPageTitle(building.name);
						});

						if (typeof report.edit_lock !== 'undefined' && typeof report.edit_lock_user_id !== 'undefined') {
							if (report.status !== 'closed') {
								if (report.edit_lock === true && (<any>report.edit_lock_user_id === '' ||
									report.edit_lock_user_id === null ||
									report.edit_lock_user_id === 0 ||
									report.edit_lock_user_id === user.id ||
									user.type === 'kvvm-admin')) {
									this.reportEditable = true;
								}
							}
						}
					}
				});
			});

			if (this.report_type === 'warehouse') {
				this.reportsBuildingsReportEditForm.addControl('location_nr', new FormControl('', Validators.required));
				this.reportsBuildingsReportEditForm.addControl('lib_warehouse_element_id', new FormControl('', Validators.required));
				this.reportsBuildingsReportEditForm.addControl('lib_warehouse_subelement_id', new FormControl('', Validators.required));
				this.reportsBuildingsReportEditForm.addControl('color_code', new FormControl('', Validators.required));
				this.reportsBuildingsReportEditForm.addControl('measure_depth', new FormControl('', Validators.required));
				this.reportsBuildingsReportEditForm.addControl('measure_height', new FormControl('', Validators.required));
				this.reportsBuildingsReportEditForm.addControl('warehouse_type_ids', new FormArray([]));
				this.reportsBuildingsReportEditForm.addControl('warehouse_type_field_value', new FormGroup({}));
				this.reportsBuildingsReportEditForm.addControl('warehouse_action_ids', new FormArray([]));
				this.reportsBuildingsReportEditForm.addControl('category_name', new FormControl(''));
				this.reportsBuildingsReportEditForm.addControl('subcategory_name', new FormControl(''));
			} else if (this.report_type === 'ladders') {
				this.reportsBuildingsReportEditForm.addControl('location_nr', new FormControl('', Validators.required));
				this.reportsBuildingsReportEditForm.addControl('ladder_id', new FormControl('', Validators.required));
				this.reportsBuildingsReportEditForm.addControl('lib_ladder_element_id', new FormControl('', Validators.required));
				this.reportsBuildingsReportEditForm.addControl('lib_ladder_subelement_id', new FormControl('', Validators.required));
				this.reportsBuildingsReportEditForm.addControl('material_id', new FormControl('', Validators.required));
				this.reportsBuildingsReportEditForm.addControl('brand', new FormControl('', Validators.required));
				this.reportsBuildingsReportEditForm.addControl('sticker_posted', new FormControl('', Validators.required));
				this.reportsBuildingsReportEditForm.addControl('description', new FormControl(''));
				this.reportsBuildingsReportEditForm.addControl('ladder_questions', new FormGroup({}));
				this.reportsBuildingsReportEditForm.addControl('category_name', new FormControl(''));
				this.reportsBuildingsReportEditForm.addControl('subcategory_name', new FormControl(''));

				this.reportsBuildingsReportEditForm.get('location_nr').valueChanges
					.pipe(
						debounceTime(300),
						tap(() => this.isVerifyingLocation = true)
					)
					.subscribe(value => {
						this.locationErrorMessage = null;
						this.locationLink = null;
						this.locationNotUnique = false;
						if (typeof value === 'string') {
							if (value !== '' && value !== null) {
								this.reportsService.isExistingLadderLocationNrUnique(this.report_id, this.building_id, this.building_report_id, value).then((data: ServerResponse) => {
									if (typeof data !== 'undefined') {
										if (typeof data.data !== 'undefined') {
											if (typeof data.data.message !== 'undefined' && typeof data.data.link !== 'undefined') {
												this.locationErrorMessage = data.data.message.replace('#before#', '<a>').replace('#after#', '</a>');
												this.locationLink = data.data.link;
												this.locationNotUnique = true;
											}
										}
									}
									this.isVerifyingLocation = false;
								});
							} else {
								this.isVerifyingLocation = false;
							}
						} else {
							this.isVerifyingLocation = false;
						}
					});
				this.reportsBuildingsReportEditForm.get('ladder_id').valueChanges
					.pipe(
						debounceTime(300),
						tap(() => this.isVerifyingId = true)
					)
					.subscribe(value => {
						this.idErrorMessage = null;
						this.idLink = null;
						this.idNotUnique = false;
						if (typeof value === 'string') {
							if (value !== '' && value !== null) {
								this.reportsService.isExistingLadderIDUnique(this.report_id, this.building_id, this.building_report_id, value).then((data: ServerResponse) => {
									if (typeof data !== 'undefined') {
										if (typeof data.data !== 'undefined') {
											if (typeof data.data.message !== 'undefined' && data.data.link !== 'undefined') {
												this.idErrorMessage = data.data.message.replace('#before#', '<a>').replace('#after#', '</a>');
												this.idLink = data.data.link;
												this.idNotUnique = true;
											}
										}
									}
									this.isVerifyingId = false;
								});
							} else {
								this.isVerifyingId = false;
							}
						} else {
							this.isVerifyingId = false;
						}
					});
			} else {
				this.reportsBuildingsReportEditForm.addControl('tent_id', new FormControl('', Validators.required));
				this.reportsBuildingsReportEditForm.addControl('lib_tent_element_id', new FormControl('', Validators.required));
				this.reportsBuildingsReportEditForm.addControl('lib_tent_subelement_id', new FormControl('', Validators.required));
				this.reportsBuildingsReportEditForm.addControl('description', new FormControl(''));
				this.reportsBuildingsReportEditForm.addControl('tent_questions', new FormGroup({}));
				this.reportsBuildingsReportEditForm.addControl('category_name', new FormControl(''));
				this.reportsBuildingsReportEditForm.addControl('subcategory_name', new FormControl(''));

				this.reportsBuildingsReportEditForm.get('tent_id').valueChanges
					.pipe(
						debounceTime(300),
						tap(() => this.isVerifyingId = true)
					)
					.subscribe(value => {
						this.idErrorMessage = null;
						this.idLink = null;
						this.idNotUnique = false;
						if (typeof value === 'string') {
							if (value !== '' && value !== null) {
								this.reportsService.isExistingTentIDUnique(this.report_id, this.building_id, this.building_report_id, value).then((data: ServerResponse) => {
									if (typeof data !== 'undefined') {
										if (typeof data.data !== 'undefined') {
											if (typeof data.data.message !== 'undefined' && data.data.link !== 'undefined') {
												this.idErrorMessage = data.data.message.replace('#before#', '<a>').replace('#after#', '</a>');
												this.idLink = data.data.link;
												this.idNotUnique = true;
											}
										}
									}
									this.isVerifyingId = false;
								});
							} else {
								this.isVerifyingId = false;
							}
						} else {
							this.isVerifyingId = false;
						}
					});
			}

			this.loadData();
		});

		this.previousUrlService.setPreviousUrlIfNull('/reports/' + this.report_type + '/' + this.report_id + (this.report_status === 'closed' ? '/closed' : '') + '/buildings/' + this.building_id + '/reports');

		this._errorsSubscription = this.reportsService.errors.subscribe(errors => {
			this.formsService.processErrors(errors);
		});
	}

	ngOnDestroy(): void {
		if (this._errorsSubscription !== null) {
			this._errorsSubscription.unsubscribe();
		}

		if (this._activatedRouteSubscription !== null) {
			this._activatedRouteSubscription.unsubscribe();
		}

		if (this._authenticationServiceSubscription !== null) {
			this._authenticationServiceSubscription.unsubscribe();
		}

		this.clearAddedPhotos();
	}

	redirectLocationNr() {
		if (this.locationLink !== null) {
			this.previousUrlService.goTo(this.locationLink);
		}
	}

	redirectId() {
		if (this.idLink !== null) {
			this.previousUrlService.goTo(this.idLink);
		}
	}

	getSubcategories(category_id: number) {
		this.category_id = category_id;
		this.actions = [];
		this.types = [];
		this.questionnaire = [];
		this.reportsService.getShortcomingSubcategories(this.report_type, category_id).then((data: ServerResponse) => {
			if (typeof data !== 'undefined') {
				if (typeof data.data !== 'undefined') {
					this.subcategories = <ReportsShortcomingsSubcategories[]>data.data;
				}
			}
		});
	}

	getDetails(subcategory_id: number) {
		this.subcategory_id = subcategory_id;

		if (this.report_type === 'warehouse') {
			this.reportsService.getShortcomingTypes(this.report_type, this.category_id, this.subcategory_id).then((data: ServerResponse) => {
				if (typeof data !== 'undefined') {
					if (typeof data.data !== 'undefined') {
						this.types = <ReportsShortcomingsTypes[]>data.data;

						const form = this.reportsBuildingsReportEditForm;
						form.removeControl('warehouse_type_ids');
						form.removeControl('warehouse_type_field_value');
						form.addControl('warehouse_type_ids', new FormArray([]));
						form.addControl('warehouse_type_field_value', new FormGroup({}));

						const control = <FormArray>this.reportsBuildingsReportEditForm.get('warehouse_type_ids'),
							control2 = <FormGroup>this.reportsBuildingsReportEditForm.get('warehouse_type_field_value');

						data.data.forEach((data2, index) => {
							control.push(new FormControl(data2.id));

							if (data2.amounts === true) {
								control2.addControl(data2.id, new FormControl(''));
							}

							control.get(index + '').setValue(false);
						});
					} else {
						this.missingData.push('Type tekortkomingen');
					}
				} else {
					this.missingData.push('Type tekortkomingen');
				}

			});

			this.reportsService.getShortcomingActions(this.report_type, this.category_id, this.subcategory_id).then((data: ServerResponse) => {
				if (typeof data !== 'undefined') {
					if (typeof data.data !== 'undefined') {
						this.actions = <ReportsShortcomingsActions[]>data.data;
						const form = this.reportsBuildingsReportEditForm;
						form.removeControl('warehouse_action_ids');
						form.addControl('warehouse_action_ids', new FormArray([]));

						const control = <FormArray>this.reportsBuildingsReportEditForm.get('warehouse_action_ids');
						data.data.forEach((data2, index) => {
							control.push(new FormControl(data2.id));

							control.get(index + '').setValue(false);
						});
					} else {
						this.missingData.push('Acties');
					}
				} else {
					this.missingData.push('Acties');
				}
			});
		} else {
			if (this.report_type === 'ladders') {
				this.reportsService.getShortcomingMaterials(this.report_type).then((data: ServerResponse) => {
					if (typeof data !== 'undefined') {
						if (typeof data.data !== 'undefined') {
							this.materials = <ReportsShortcomingsMaterials[]>data.data;
						} else {
							this.missingData.push('Materiaal');
						}
					} else {
						this.missingData.push('Materiaal');
					}
				});
			}

			this.reportsService.getShortcomingQuestionnaires(this.report_type, this.category_id, this.subcategory_id).then((data: ServerResponse) => {
				if (typeof data !== 'undefined') {
					if (typeof data.data !== 'undefined') {
						this.questionnaire = <ReportsBuildingsShortcomingsQuestionnaire[]>data.data;

						const form = this.reportsBuildingsReportEditForm,
							formControlName = this.report_type === 'ladders' ? 'ladder_questions' : 'tent_questions';
						form.removeControl(formControlName);
						form.addControl(formControlName, new FormGroup({}));

						const control = <FormGroup>this.reportsBuildingsReportEditForm.get(formControlName);
						data.data.forEach(data2 => {
							if (typeof data2.questions !== 'undefined') {
								data2.questions.forEach(data3 => {
									control.addControl('[' + data2.id + '][' + data3.id + ']', new FormControl(data3.id));

									control.get('[' + data2.id + '][' + data3.id + ']').setValue('yes');
								});
							}
						});
					} else {
						this.missingData.push('Schema');
					}
				} else {
					this.missingData.push('Schema');
				}
			});
		}
	}

	fixAngularScrewUpAndInsertActualValue(control_name, event, index) {
		if (event.checked) {
			this.reportsBuildingsReportEditForm.controls[control_name]['controls'][index].setValue(parseInt(event.source.value, 10));
		}
	}

	deleteBuildingReportPhoto(type: string, photo_id: number, index: number) {
		this.reportsService.deleteBuildingReportPhoto(this.report_type, this.report_id, this.building_id, this.building_report_id, photo_id).then(status => {
			if (status === true) {
				this.buildingReport.photos[type].splice(index, 1);
				this.offlinePhoto.splice(index, 1);
			}
		});
	}

	scanBarcode() {
		let dialogRef: MatDialogRef<BarcodeScannerComponent>;
		dialogRef = this.dialogService.open(BarcodeScannerComponent);
		dialogRef.afterClosed().subscribe(response => {
			this.reportsBuildingsReportEditForm.get('location_nr').setValue(response);
		});
	}

	recognizeSpeechToText() {
		let dialogRef: MatDialogRef<SpeechToTextComponent>;
		dialogRef = this.dialogService.open(SpeechToTextComponent);
		dialogRef.afterClosed().subscribe(response => {
			this.reportsBuildingsReportEditForm.get('location_nr').setValue(response);
		});
	}

	decreaseValue(element, toggleElement = null) {
		const el = this.reportsBuildingsReportEditForm.get(element),
			val = parseInt(el.value, 10);

		el.setValue(val > 1 ? val - 1 : '');
		if (val === 1 && toggleElement !== null) {
			let te = toggleElement.split('.');
			this.reportsBuildingsReportEditForm.get(te[0]).get(te[1]).setValue(false);
		}
	}

	increaseValue(element, toggleElement = null, id = null) {
		const el = this.reportsBuildingsReportEditForm.get(element),
			val = parseInt(el.value, 10);

		el.setValue(isNaN(val) ? 1 : val + 1);
		if (toggleElement !== null) {
			let te = toggleElement.split('.');
			this.reportsBuildingsReportEditForm.get(te[0]).get(te[1]).setValue(id);
		}
	}

	loadData() {
		this.reportsService.getShortcomingCategories(this.report_type).then((data: ServerResponse) => {
			if (typeof data !== 'undefined') {
				if (typeof data.data !== 'undefined') {
					this.categories = <ReportsShortcomingsCategories[]>data.data;
				} else {
					this.missingData.push('Hoofd onderdeel');
				}
			} else {
				this.missingData.push('Hoofd onderdeel');
			}
		});

		this.reportsService.getBuildingReport(this.report_type, this.report_id, this.building_id, this.building_report_id).then((data: ReportsBuildingsReports) => {
			if (typeof data !== 'undefined') {
				this.buildingReport = data;

				if (typeof data.verify_status !== 'undefined') {
					if (data.verify_status === <any>false) {
						data.verify_status = '0';
					} else if (data.verify_status === <any>true) {
						data.verify_status = '1';
					}
				}

				if (typeof data.photos !== 'undefined') {
					if (typeof data.photos.inspector !== 'undefined') {
						if (data.photos.inspector.length) {
							this.initialPhotosCount = data.photos.inspector.length;
							data.photos.inspector.forEach((photo, index) => {
								if (typeof photo.offline !== 'undefined') {
									this.reportsService.getOfflinePhotos(this.report_id, this.building_id, this.building_report_id, photo.id).then(result => {
										this.offlinePhoto[index] = result;
									});
								}
							});
						}
					}
				}

				if (this.report_type === 'warehouse') {
					this.category_id = data.lib_warehouse_element_id;
					this.subcategory_id = data.lib_warehouse_subelement_id;

					this.reportsService.getShortcomingSubcategories(this.report_type, data.lib_warehouse_element_id).then((data2: ServerResponse) => {
						if (typeof data2 !== 'undefined') {
							if (typeof data2.data !== 'undefined') {
								this.subcategories = <ReportsShortcomingsSubcategories[]>data2.data;

								this.reportsBuildingsReportEditForm.get('lib_warehouse_subelement_id').setValue(data.lib_warehouse_subelement_id);

								this.reportsService.getShortcomingTypes(this.report_type, this.category_id, this.subcategory_id).then((data3: ServerResponse) => {
									if (typeof data3 !== 'undefined') {
										if (typeof data3.data !== 'undefined') {
											this.types = <ReportsShortcomingsTypes[]>data3.data;

											const control = <FormArray>this.reportsBuildingsReportEditForm.get('warehouse_type_ids'),
												control2 = <FormGroup>this.reportsBuildingsReportEditForm.get('warehouse_type_field_value');

											data3.data.forEach((data4, index) => {
												control.push(new FormControl(data4.id));

												if (data4.amounts === true) {
													control2.addControl(data4.id, new FormControl(''));

													if (typeof data.warehouse_type_field_value !== 'undefined') {
														if (typeof data.warehouse_type_field_value[data4.id] !== 'undefined') {
															this.reportsBuildingsReportEditForm.get('warehouse_type_field_value.' + data4.id).setValue(data.warehouse_type_field_value[data4.id]);
														}
													}
												}

												const thisControl = this.reportsBuildingsReportEditForm.get('warehouse_type_ids').get(index + '');
												if (typeof data.warehouse_type_ids !== 'undefined') {
													if (data.warehouse_type_ids !== null) {
														if (data.warehouse_type_ids.indexOf(thisControl.value) === -1) {
															thisControl.setValue(false);
														}
													} else {
														thisControl.setValue(false);
													}
												} else {
													thisControl.setValue(false);
												}
											});

											this.reportsService.getShortcomingActions(this.report_type, this.category_id, this.subcategory_id).then((data4: ServerResponse) => {
												if (typeof data4 !== 'undefined') {
													if (typeof data4.data !== 'undefined') {
														this.actions = <ReportsShortcomingsActions[]>data4.data;

														const control3 = <FormArray>this.reportsBuildingsReportEditForm.get('warehouse_action_ids');
														data4.data.forEach((data5, index) => {
															control3.push(new FormControl(data5.id));

															const thisControl = this.reportsBuildingsReportEditForm.get('warehouse_action_ids').get(index + '');
															if (typeof data.warehouse_action_ids !== 'undefined') {
																if (data.warehouse_action_ids !== null) {
																	if (data.warehouse_action_ids.indexOf(thisControl.value) === -1) {
																		thisControl.setValue(false);
																	}
																} else {
																	thisControl.setValue(false);
																}
															} else {
																thisControl.setValue(false);
															}
														});
														this.formsService.populateForm(data);

														this.dataLoaded = true;
													} else {
														this.missingData.push('Acties');
													}
												} else {
													this.missingData.push('Acties');
												}
											});
										} else {
											this.missingData.push('Types');
										}
									} else {
										this.missingData.push('Types');
									}
								});
							} else {
								this.missingData.push('Subcategories');
							}
						} else {
							this.missingData.push('Subcategories');
						}
					});
				} else if (this.report_type === 'ladders') {
					this.category_id = data.lib_ladder_element_id;
					this.subcategory_id = data.lib_ladder_subelement_id;

					this.reportsService.getShortcomingSubcategories(this.report_type, data.lib_ladder_element_id).then((data2: ServerResponse) => {
						if (typeof data2 !== 'undefined') {
							if (typeof data2.data !== 'undefined') {
								this.subcategories = <ReportsShortcomingsSubcategories[]>data2.data;

								this.reportsBuildingsReportEditForm.get('lib_ladder_subelement_id').setValue(data.lib_ladder_subelement_id);
							} else {
								this.missingData.push('Subcategories');
							}
						} else {
							this.missingData.push('Subcategories');
						}
					});

					this.reportsService.getShortcomingMaterials(this.report_type).then((data2: ServerResponse) => {
						if (typeof data2 !== 'undefined') {
							if (typeof data2.data !== 'undefined') {
								this.materials = <ReportsShortcomingsMaterials[]>data2.data;

								this.reportsBuildingsReportEditForm.get('material_id').setValue(data.material_id);

								this.reportsService.getShortcomingQuestionnaires(this.report_type, this.category_id, this.subcategory_id).then((data3: ServerResponse) => {
									if (typeof data3 !== 'undefined') {
										if (typeof data3.data !== 'undefined') {
											this.reportsService.getShortcomingQuestionnaireAnswer(this.report_type, this.report_id, this.building_report_id).then((answer: any) => {
												this.questionnaire = <ReportsBuildingsShortcomingsQuestionnaire[]>data3.data;

												const control = <FormGroup>this.reportsBuildingsReportEditForm.get('ladder_questions');
												data3.data.forEach(data4 => {
													data4.questions.forEach(data5 => {
														control.addControl('[' + data4.id + '][' + data5.id + ']', new FormControl(data5.id));
														let answer2 = (typeof answer !== 'undefined' ? (typeof answer.questions !== 'undefined' ? (typeof answer.questions[data5.id] !== 'undefined' ? answer.questions[data5.id] : null) : null) : null);

														const thisControl = control.get('[' + data4.id + '][' + data5.id + ']');
														if (answer2 === 'yes' || answer2 === 'no' || answer2 === 'n/a') {
															thisControl.setValue(answer2);
														} else {
															thisControl.setValue(false);
														}
													});
												});
											});
										}
									}
									this.formsService.populateForm(data);

									this.dataLoaded = true;
								});
							} else {
								this.missingData.push('Materiaal');
							}
						} else {
							this.missingData.push('Materiaal');
						}
					});
				} else {
					this.category_id = data.lib_tent_element_id;
					this.subcategory_id = data.lib_tent_subelement_id;

					this.reportsService.getShortcomingSubcategories(this.report_type, data.lib_tent_element_id).then((data2: ServerResponse) => {
						if (typeof data2 !== 'undefined') {
							if (typeof data2.data !== 'undefined') {
								this.subcategories = <ReportsShortcomingsSubcategories[]>data2.data;

								this.reportsBuildingsReportEditForm.get('lib_tent_subelement_id').setValue(data.lib_tent_subelement_id);
							} else {
								this.missingData.push('Subcategories');
							}
						} else {
							this.missingData.push('Subcategories');
						}
					});

					this.reportsService.getShortcomingQuestionnaires(this.report_type, this.category_id, this.subcategory_id).then((data3: ServerResponse) => {
						if (typeof data3 !== 'undefined') {
							if (typeof data3.data !== 'undefined') {
								this.reportsService.getShortcomingQuestionnaireAnswer(this.report_type, this.report_id, this.building_report_id).then((answer: any) => {
									this.questionnaire = <ReportsBuildingsShortcomingsQuestionnaire[]>data3.data;

									const control = <FormGroup>this.reportsBuildingsReportEditForm.get('tent_questions');
									data3.data.forEach(data4 => {
										if (typeof data4.questions !== 'undefined') {
											if (data4.questions.length) {
												data4.questions.forEach(data5 => {
													control.addControl('[' + data4.id + '][' + data5.id + ']', new FormControl(data5.id));
													let answer2 = (typeof answer !== 'undefined' ? (typeof answer.questions !== 'undefined' ? (typeof answer.questions[data5.id] !== 'undefined' ? answer.questions[data5.id] : null) : null) : null);

													const thisControl = control.get('[' + data4.id + '][' + data5.id + ']');
													if (answer2 === 'yes' || answer2 === 'no' || answer2 === 'n/a') {
														thisControl.setValue(answer2);
													} else {
														thisControl.setValue(false);
													}
												});
											}
										}
									});
								});
							}
						}
						this.formsService.populateForm(data);

						this.dataLoaded = true;
					});
				}
			} else {
				this.missingData.push('Schade');
			}
		});
	}

	setCategoryName(category_name: string) {
		this.reportsBuildingsReportEditForm.get('category_name').setValue(category_name);
	}

	setSubcategoryName(subcategory_name: string) {
		this.reportsBuildingsReportEditForm.get('subcategory_name').setValue(subcategory_name);
	}

	clearAddedPhotos(): void {
		if (this.photosRef.length) {
			this.photosRef.forEach(ref => ref.destroy());
		}
	}

	detectUploadFiles(event: any): void {
		if (typeof event !== 'undefined') {
			if (typeof event.target !== 'undefined') {
				if (typeof event.target.files !== 'undefined') {
					let formArray = this.reportsBuildingsReportEditForm.get('photos') as FormArray;

					Object.keys(event.target.files).map(file => {
						this.photosCount = this.initialPhotosCount + formArray.controls.length + 1;

						if (this.photosCount < 11) {
							const factory: ComponentFactory<any> = this.resolver.resolveComponentFactory(RemovablePhotoComponent);
							let component: any = null;
							component = this.photos.createComponent(factory);
							component.instance.photo = event.target.files[file];
							component.instance.filename = event.target.files[file].name;
							component.instance.size = event.target.files[file].size;

							this.photosRef.push(component);

							let control = new FormControl(event.target.files[file]);
							formArray.push(control);

							component.instance.destroy.subscribe(() => {
								let index = this.photos.indexOf(component.hostView);
								formArray.removeAt(index);
								component.destroy();
								this.photosCount = this.initialPhotosCount + formArray.controls.length;
							});
						}
					});
				}
			}
		}
	}

	showBuildingMap() {
		this.reportsService.showReportBuildingMap(this.buildingMapUrl, false, this.buildingMapMarkers).then((returnedMarkers: ReportsBuildingsMapsMarker[]) => {
			this.buildingMapMarkers = returnedMarkers;

			let formArray = this.reportsBuildingsReportEditForm.get('marker') as FormArray;
			formArray.clear();

			returnedMarkers.forEach(marker => {
				let control = new FormControl(marker.x + ',' + marker.y);

				formArray.push(control);
			});
		});
	}

	addTentLocationNr(): void {
		this.reportsBuildingsReportEditForm.addControl('location_nr', new FormControl('', Validators.required));

		this.reportsBuildingsReportEditForm.get('location_nr').valueChanges
			.pipe(
				debounceTime(300),
				tap(() => this.isVerifyingLocation = true)
			)
			.subscribe(value => {
				this.locationErrorMessage = null;
				this.locationLink = null;
				this.locationNotUnique = false;
				if (typeof value === 'string') {
					if (value !== '' && value !== null) {
						this.reportsService.isExistingTentLocationNrUnique(this.report_id, this.building_id, this.building_report_id, value).then((data: ServerResponse) => {
							if (typeof data !== 'undefined') {
								if (typeof data.data !== 'undefined') {
									if (typeof data.data.message !== 'undefined' && typeof data.data.link !== 'undefined') {
										this.locationErrorMessage = data.data.message.replace('#before#', '<a>').replace('#after#', '</a>');
										this.locationLink = data.data.link;
										this.locationNotUnique = true;
									}
								}
							}
							this.isVerifyingLocation = false;
						});
					} else {
						this.isVerifyingLocation = false;
					}
				} else {
					this.isVerifyingLocation = false;
				}
			});
	}
}
